import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DestructionTypesActions } from '../actions';
import { NotifierService } from 'angular-notifier';
import { DestructionTypesService } from '../../services/destruction-types.service';

@Injectable()
export class DestructionTypesEffects {
  redDestructionType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DestructionTypesActions.ReadDestructionType),
      map(action => action),
      switchMap(({ iri }) => {
        return this.service.readDestructionType(iri).pipe(
          map(response =>
            DestructionTypesActions.ReadDestructionTypeSuccess({ response })
          ),
          catchError(response =>
            of(DestructionTypesActions.ReadDestructionTypeFail({ response }))
          )
        );
      })
    )
  );
  readDestructionTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DestructionTypesActions.ReadDestructionTypes),
      map(action => action),
      switchMap(() => {
        return this.service.readDestructionTypes().pipe(
          map(response =>
            DestructionTypesActions.ReadDestructionTypesSuccess({ response })
          ),
          catchError(response =>
            of(DestructionTypesActions.ReadDestructionTypesFail({ response }))
          )
        );
      })
    )
  );
  FailActions = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          DestructionTypesActions.ReadDestructionTypesFail,
          DestructionTypesActions.ReadDestructionTypeFail
        ),
        map(({ type, response }) => {
          console.log({ response });
          const errors = response?.error['hydra:description'];
          const message = 'Fehler bei der Anfrage: ' + errors;
          this.notifierService.show({ type: 'error', message });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private service: DestructionTypesService,
    private notifierService: NotifierService
  ) {}
}
